
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 (function() {
    // Change stamped reviews widged when it has been added to DOM
    function on_stamped_reviews_loaded() {
        let stamped_header = tt('#stamped-main-widget .stamped-header-title');
        stamped_header.attr('aria-expanded', 'false');
        stamped_header.append(tt('button.card__collapsible-button .plus-button--large').cloneNode(true));
        stamped_header.listen('click', (e) => {
            let content = tt('#stamped-main-widget .stamped-content');
            let target = e.target.closest('.stamped-header-title');
            //hold(content);
            if (target.attr('aria-expanded') == "false") {
                target.attr('aria-expanded', "true");
                content.css(`height: ${content.scrollHeight}px`);
            } else if (target.attr('aria-expanded') == "true") {
                target.attr('aria-expanded', "false");
                content.css(`height: 0`);
            }
        });
    }
    
    function hold(whom) {
        let parent =  tt('.product-block-list__item.product-block-list__item--info');
        let card = tt('.product-block-list__item.product-block-list__item--info .card');
        let dd = $('.product-block-list__item.product-block-list__item--info .card');
        let distance_from_bottom = Number(Number((window.innerHeight + window.scrollY) - (card.clientHeight + dd.offset().top)).toFixed(2));
        let distance_from_top = Number(Number(window.innerHeight - (card.clientHeight + distance_from_bottom)).toFixed(2));	
    
        if (parent.clientHeight > card.offsetHeight + card.offsetTop) {
            console.log('not bottom');
    
        } else {
            console.log('bottom');
            card.css(`top: ${card.offsetTop}px`);
            card.css(`position: absolute`);
            whom.listen('transitionend', () => {
                console.log('transtition has ended');
                card.css(`top: ${distance_from_top}x`);
                card.css(`position: sticky`);
            });
        }
    }
    
    // Liten for changes on Frame size and update the frame prices.
    tt('.product-form__variants .product-form__option.Size select').listen('change', function(e) {
        let price_arr = e.target.options[e.target.selectedIndex].getAttribute('data-frame-prices').split("%&");
        price_arr.shift();
        let frame_arr = Object.values(t('.product-form__variants .product-form__option.Frame select option'));
        frame_arr.shift();
        let counter = 0;
        frame_arr.forEach(function(el) {
            let in_text = el.innerText;
            el.innerText = in_text.replace(/\(+.*\)/, `(+${price_arr[counter]})`);
            counter++;
        });
    });
    
    // Handle cliks and hover on additional info icons.
    let on_infinity_options_loaded = function() {
        tt('form.product-form #infiniteoptions-container .white_border_field label').append(t().mkEle(document.additionl_border_info));
    
        tt('form.product-form #infiniteoptions-container .white_border_field select').attr('data-select-name', "WhiteBorder");
    
        t('.addition_info_block').listen('mouseenter',function(e) {
            let el = t('.add-info-content', e.target.closest('.addition_info_block'));
            el.removeClass('no-display');
            el.addClass('is-visible');
        });
    
        t('.addition_info_block').listen('mouseleave',function(e) {
            let el = t('.add-info-content', e.target.closest('.addition_info_block'));
            el.animate('is-visible', () => {
                el.addClass('no-display');
            }, "reverse");
        });
    
        t('.addition_info_block').listen('click',function(e) {
            let el = tt('.add-info-content', e.target.closest('.addition_info_block'));
            if (!el.hasClass('is-visible')) {
                el.removeClass('no-display');
                el.addClass('is-visible');
            }
            e.preventDefault();
        });
    
        tt('body').listen('click',function(e) {
            if (!e.target.closest('.addition_info_block')) {
                let el = t('.addition_info_block .add-info-content');
                el.each((element) => {
                    if (element.hasClass('is-visible')) {
                        element.animate('is-visible', () => {
                            el.addClass('no-display');
                        }, "reverse");
                    }
                });
            }
        });
    }
    
    // Re add add info icon when Frame select option is changed
    tt('.product-form__option.Frame select').listen('change', () => {
        // Re add event listeners
        setTimeout(() => {
        if (tt('.product-form__option.Frame label .addition_info_block').constructor.name == "tlite") {
        tt('.product-form__option.Frame label').append(t().mkEle(document.additionl_border_info_2));	
    
        tt(' .product-form__option.Frame .addition_info_block').listen('mouseenter',function(e) {
            let el = t('.add-info-content', e.target.closest('.addition_info_block'));
            el.removeClass('no-display');
            el.addClass('is-visible');
        });
    
        tt('.product-form__option.Frame .addition_info_block').listen('mouseleave',function(e) {
            let el = t('.add-info-content', e.target.closest('.addition_info_block'));
            el.animate('is-visible', () => {
                el.addClass('no-display');
            }, "reverse");
        });
    
        tt('.product-form__option.Frame .addition_info_block').listen('click',function(e) {
            let el = tt('.add-info-content', e.target.closest('.addition_info_block'));
            if (!el.hasClass('is-visible')) {
                el.removeClass('no-display');
                el.addClass('is-visible');
            }
            e.preventDefault();
        });
        }
        },100);
    });
    
    // Handle cliks on product tabs
    t('.custom-product-tabs .header-tab .inner').listen('click', (e) => {
        let this_el = e.target.closest('.header-tab');
        let tab_number = this_el.attr('data-tab-index');
        t('.custom-product-tabs .header-tab').removeClass('open');
        this_el.addClass('open');
        t('.custom-product-tabs .content-tab').removeClass('open');
        t('.custom-product-tabs .content-tab[data-tab-index="' + tab_number + '"]').addClass('open');	
    });
    
    // Execute functions when infinity options and stamped reviews have been loaded
    if (document.body.attr("data-infinityOptionsLoaded") == "true") {
        on_infinity_options_loaded();
    } else {
        window.addEventListener('infinityOptionsLoaded', (e) => {
            on_infinity_options_loaded();
        });
    }
    
    if (document.body.attr("data-stampedReviewsLoaded") == "true") {
        on_stamped_reviews_loaded();
    } else {
        window.addEventListener('stampedReviewsLoaded', (e) => {
            on_stamped_reviews_loaded();
        });
    }
    
    }());